import { QuestionAccordion, AccordionList } from "../../../../src/components/FAQ/QuestionAccordion";
import * as React from 'react';
export default {
  QuestionAccordion,
  AccordionList,
  React
};